import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

// Route (pathname) her değiştiğinde sayfayı en üste kaydırır.
// React Router SPA geçişlerinde scroll konumunu otomatik sıfırlamaz;
// bu bileşen onu düzeltir. Görsel çıktısı yoktur (null döner).
export const ScrollToTop = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    // 'instant' -> anında en üste (smooth istersen 'smooth' yap)
    window.scrollTo({ top: 0, left: 0, behavior: 'instant' });
  }, [pathname]);

  return null;
};

export default ScrollToTop;